import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { MaPortAgent } from "src/app/modules/Disbursment_modules/dis-repository/pages/create-port-agent/port-agent.model";

@Injectable({
  providedIn: 'root'
})
export class PortAgentService {

  constructor(private http: CommonHttpModule) { }

  portAgentDataFromDb(params: any): Observable<{ data: MaPortAgent[]; total_count: number }> {
    return this.http.post<{ total_count: number; data: MaPortAgent[] }>("port-agentlist", params).pipe(
      map(response => ({
        total_count: response.total_count,
        data: response.data
      }))
    );
  }

  PortAgentDataToDb(data: MaPortAgent): Observable<any> {
    return this.http.post("port-agent", data).pipe(
      map((response) => {
        return response;
      })
    )
  }

}